import { render, staticRenderFns } from "./subCircuits.vue?vue&type=template&id=ddb5f8e0&scoped=true"
import script from "./subCircuits.vue?vue&type=script&lang=js"
export * from "./subCircuits.vue?vue&type=script&lang=js"
import style0 from "./subCircuits.vue?vue&type=style&index=0&id=ddb5f8e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb5f8e0",
  null
  
)

export default component.exports